import { Text, View } from "react-native";
import { LargeText } from "ui/molecules/common/LargeText";
import { useResidentContext } from "../../provider/ResidentProvider";
import KeyValueGrid from "ui/organisms/KeyValueGrid";
import { GridItem } from "ui/types/GridItem";
import { useMemo, useRef } from "react";
import { EditResidentAllergiesModal } from "../modals/EditResidentAllergiesModal";
import { EditButton } from "../../molecules/EditButton";
import ViewDocuments from "app/components/molecules/ViewDocuments";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";

export default function ResidentAllergiesDietTemplate() {
  const { resident } = useResidentContext();
  const ref =
    useRef<React.ComponentRef<typeof EditResidentAllergiesModal>>(null);
  const startEdit = () => {
    ref.current?.show(resident);
  };

  const formattedItems = useMemo(() => {
    let added = false;
    const foodCategory = {
      label: "Solid food",
      value: "",
      sortKey: 0,
    };

    return (
      resident?.diet_categories?.flatMap(
        ({ diet_category: dietCategory, description }) => {
          const values: GridItem[] = [];

          if (description) {
            values.push({
              label: "Note",
              value: description,
              sortKey: dietCategory.id,
            });
          } else if (dietCategory.parent) {
            values.push({
              label: dietCategory.parent.name,
              value: dietCategory.name,
              sortKey: dietCategory.id,
            });
          } else {
            if (added) {
              foodCategory.value += `${dietCategory.name}\n\n`;
            } else {
              foodCategory.value = `${dietCategory.name}\n\n`;
              values.push(foodCategory);

              added = true;
            }
          }

          return values;
        },
      ) || []
    );
  }, [resident?.diet_categories]);

  return (
    <View className="resident-container">
      <EditButton
        startEdit={startEdit}
        permission={PermissionsEnums.UPDATE_RESIDENT}
      />
      {resident?.allergies ? (
        <>
          <LargeText
            title="General"
            text={resident?.allergies || "No allergy notes"}
            className="mb-8"
          />
          <ViewDocuments documents={resident?.allergies_media || []} />
        </>
      ) : (
        <Text className="text-typography-600">No allergies listed.</Text>
      )}
      <View className="border border-gray-200 w-full my-12" />

      {formattedItems.length ? (
        <KeyValueGrid title="Diet Specific Allergies" items={formattedItems} />
      ) : (
        <Text className="text-typography-600">
          No diet specific allergies listed.
        </Text>
      )}

      <EditResidentAllergiesModal ref={ref} />
    </View>
  );
}
